import { SBTypography, SBBox } from "modules/Commons";
import { useTranslation } from "react-i18next";

export default ({
	lineColor,
	lineBackground,
	title,
	value,
	min,
	max
}: SBForecastInfoTooltipProps) => {
	const { t } = useTranslation();

	return (
		<SBBox mt={0.5}>
			<SBBox display="flex" alignItems="center">
				<SBBox mr={1}>
					<div
						style={{
							height: 5,
							width: 15,
							background: `${lineBackground}`,
							content: "",
						}}
					/>
					<div
						style={{
							height: 3,
							width: 15,
							background: lineColor,
							content: "",
						}}
					/>
					<div
						style={{
							height: 5,
							width: 15,
							background: `${lineBackground}`,
							content: "",
						}}
					/>
				</SBBox>
				<SBTypography mr={2}>{t(title)}</SBTypography>
				<SBTypography ml="auto">
					{value?.systemFormat({
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					})}
				</SBTypography>
			</SBBox>
			<SBBox display="flex">
				<SBTypography ml={2.9} mr={2}>
					{t("min")}
				</SBTypography>
				<SBTypography ml="auto">
					{min?.systemFormat({
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					})}
				</SBTypography>
			</SBBox>
			<SBBox display="flex">
				<SBTypography ml={2.9} mr={2}>
					{t("max")}
				</SBTypography>
				<SBTypography ml="auto">
					{max?.systemFormat({
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					})}
				</SBTypography>
			</SBBox>
		</SBBox>
	);
};

export interface SBForecastInfoTooltipProps {
	lineColor: string;
	lineBackground: string;
	title: string;
	value: number;
	min: number;
	max: number;
}
